var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"chat-image",class:{ 'chat-image--failed': _vm.failed },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('open')}}},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":""}}):(_vm.failed)?_c('span',{staticClass:"chat-image__failed"},[_vm._v("!")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39e7947a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Systems/Tickets/ChatImage.vue
// module id = 2301
// module chunks = 7